import { Component, ElementRef, Input, AfterViewInit, ViewChild, HostListener, Injector } from "@angular/core";
import { Subscription } from "rxjs";
import { BoxQuotaData } from "../../model/box.quote.data";
import { AChartComponent } from "../achart/achart.component";
import { StockSeriesType } from "../achart/achart.annotation.tools";
import { historyPeriods, HistoryItemPeriod, getPeriodCss } from "../../interfaces/historyItem";
import { RangeButtonService } from "../../services/rangeButtonService/rangeButtonService.service";
import { ResizeService } from "../../services/ResizeService/resize.service";

// tslint:disable-next-line:typedef
import * as $ from "jquery";
import { IChartConfig } from "../../interfaces/IChartConfig";
import { SymbolTypeEnum } from "../../enums/SymbolType.enum";
import { AppComponentBase } from "../../services/AppComponentBase";
import { WorkspaceEventType } from "../../services/workspace-event-type.enum";
import { WorkspaceEventData } from "../../services/workspace-event-data";
import { Providers } from "../../enums/providers";

@Component({
    selector: "chart-quotepanel",
    template: require('./chart.quotepanel.component.html'),
    styles: [
        require('./chart.quotepanel.component.css'),
        require('../../appStyles.css'),
        require('../quotePanelTabs/quotePanelTabs.component.css')
    ]
})
export class ChartQuotePanel extends AppComponentBase implements AfterViewInit {
    @ViewChild("periodsSelector")
    periodsSelector: ElementRef | undefined;

    @Input()
    name: string = "";

    @Input()
    title: string = "";

    private _updatePeriod?: HistoryItemPeriod;
    public get updatePeriod(): HistoryItemPeriod | undefined {
        return this._updatePeriod;
    }

    private _symbol: string = "";

    @Input()
    isselected: boolean = false;

    @Input()
    set achart(v) {
        if (v == this._achart) return;

        this._achart = v;

        this._symbol = this.workspace.charts[this.aChartId].Symbol;

        this.setMonitorPeriods(v);
    }

    get achart() {
        return this._achart;
    }

    _achart: any = null;

    public get chartButtonsVisible() {
        return this.Config.ChartButtonsVisible;
    }

    public set chartButtonsVisible(v: boolean) {
        this.Config.ChartButtonsVisible = v;
    }

    public get ShowTooltip(): boolean {
        return this.Config.ShowTooltip;
    }
    public set ShowTooltip(v: boolean) {
        this.Config.ShowTooltip = v;
    }

    get aChart(): AChartComponent {
        return <AChartComponent>this.achart;
    }

    get aChartId(): string {
        return this.aChart.itemID;
    }

    public get Config(): IChartConfig {
        if (this.tempSelectedSymbol != this.workspace.charts[this.aChartId].Symbol) {
            this.selectedSymbol = this.workspace.charts[this.aChartId].Symbol;
            this.tempSelectedSymbol = this.workspace.charts[this.aChartId].Symbol;
        }
        return this.workspace.charts[this.aChartId];
    }

    @Input()
    set symbol(v: string) {
        if (this._symbol != v) {
            this._symbol = v;
            this.selectedSymbol = v;
        }
    }

    get symbol(): string {
        return this._symbol;
    }

    private _rangeButton: number = 2;
    private _showZoomIndicators: number = 0;
    private _showChartTypes: number = 0;
    private _showGranulityTypes: number = 0;
    private _timeOut: any = null;
    private _quoteData: any;

    public boxes: string[] = [];

    get selectedSymbol() {
        return this._selectedSymbol;
    }

    set selectedSymbol(v) {
        if (this._selectedSymbol != v) {
            this._selectedSymbol = v;
            this.onChange(v);
        }
    }

    public _selectedSymbol: any = "";

    public get activeSymbolType(): SymbolTypeEnum {
        return this.workspace.activeSymbolType;
    }
    public set activeSymbolType(v: SymbolTypeEnum) {
        this.workspace.activeSymbolType = v;
    }

    private periodsSelectorTicking: boolean = false;
    private periodsBarTravelDirection: string = "";
    private periodsBarTravelling: boolean = false;

    private tempSelectedSymbol: string = "";
    public get item(): BoxQuotaData | null {
        let res = this.workspace.boxes.filter(x => x.Symbol == this.symbol);
        return res.length > 0 ? res[0] : null;
    }

    lastType?: SymbolTypeEnum;

    refreshSymbols(t?: SymbolTypeEnum) {
        if (t != undefined) this.lastType = t;
        else t = this.lastType;

        if (t == undefined) return;

        if (this.workspace.activeBasket != -1) {
            this.filterBasketItemsByActiveBasket();
            // this.refreshSymbolAfterChanges();
        } else {
            this.boxes = this.workspace.getSymbolsTypeSlit(t).filter(l => {
                if (
                    this.workspace.competitionAccountList.indexOf(this.workspace.activeAccountIdBySet) > -1 ||
                    this.workspace.currentProvider != Providers.DEMO
                ) {
                    if (this.workspace.allowedForexSymbols.indexOf(l) > -1) {
                        //&& this.workspace.currentTournaments[0].tournamentAssets.Assets.indexOf(0))
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            });
        }
        this.refreshSymbolAfterChanges();

        this.workspace.showBackToResults = false;
    }

    constructor(injector: Injector, private rangeButtonService: RangeButtonService) {
        super(injector);

        (window as any).chartquotepanels = (window as any).chartquotepanels || [];
        (window as any).chartquotepanels.push(this);
        this.dataService.dataSubscriber.subscribe(response => {
            var T = response.T;
            setTimeout(() => {
                if (T && T.filter(x => x.S === this.symbol).length > 0) {
                    delete this._quoteData;
                    this._quoteData = T.filter(x => x.S === this.symbol)[0];
                }
            });
        });

        this.symbolTypeService.subscriber.subscribe(t => {
            this.refreshSymbols(t);
        });

        this.symbolTypeService.scanResultClick.subscribe(v => {
            //  this.boxes = v.filteredResults;

            if (this.workspace.isNarrowScanMode) {
                this.boxes = this.workspace.scanResultListNarrow.map(v => v.symbol);
            } else {
                this.boxes = this.workspace.scanResultList.map(v => v.symbol);
            }

            this.workspace.isNarrowScanMode;
            this.workspace.scanResultList;
            this.workspace.scanResultListNarrow;

            //this.boxes.filter(l=>{
            //     return  v.filteredResults.indexOf(l)>-1;
            // });

            this.workspace.showBackToResults = true;
        });

        this.rangeButtonService.subscriber.subscribe(t => {
            if (this.isselected) {
                this.rangeButton = t;
            }
            //
        });

        this.globaGridMode.subscribeShowGrid(t => {
            if (this.drawGrid != t) {
                this.drawGrid = t;
            }
        });

        this.globaGridMode.showPriceIndicatorSubscriber.subscribe(v => {
            this.showPriceIndicators = v;
        });

        this.workspace.chartDisplayModeService.subscriber.subscribe(d => {
            this.aChart.period;
            if (d == "signals") {
                this.showChartTypesButton = false;
            } else {
                this.showChartTypesButton = true;
            }
        });

        this.globaGridMode.changeActiveBasket.subscribe(x => {
            if (x != -1) {
                this.filterBasketItemsByActiveBasket();
            } else {
                this.boxes = this.workspace.getSymbolsTypeSlit(this.workspace.activeSymbolType).filter(l => {
                    if (
                        this.workspace.competitionAccountList.indexOf(this.workspace.activeAccountIdBySet) > -1 ||
                        this.workspace.currentProvider != Providers.DEMO
                    ) {
                        if (this.workspace.allowedForexSymbols.indexOf(l) > -1) {
                            //&& this.workspace.currentTournaments[0].tournamentAssets.Assets.indexOf(0))
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return true;
                    }
                });
            }
            this.refreshSymbolAfterChanges();
        });

        this.globaGridMode.refreshProviderSignal.subscribe(v => {
            if (this.aChartId == v) {
                this.historyPeriodType = this.aChart.period;
            }
        });
    }

    private filterBasketItemsByActiveBasket() {
        if (this.workspace.getActiveBasketItems() !== undefined) {
            let selected = this.workspace
                .getActiveBasketItems()
                .filter(v => {
                    let element = this.workspace.SymbolInfoes.filter(t => {
                        if (t.Symbol === v) {
                            return t.Type;
                        }
                    });
                    if (element[0].Type === this.workspace.activeSymbolType) {
                        return element[0].Symbol;
                    }
                })
                .filter(l => {
                    if (
                        this.workspace.competitionAccountList.indexOf(this.workspace.activeAccountIdBySet) > -1 ||
                        this.workspace.currentProvider != Providers.DEMO
                    ) {
                        if (this.workspace.allowedForexSymbols.indexOf(l) > -1) {
                            //&& this.workspace.currentTournaments[0].tournamentAssets.Assets.indexOf(0))
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return true;
                    }
                });

            this.boxes = selected;
            this.workspace.AppTick();
        }
    }

    private refreshSymbolAfterChanges() {
        if (this.aChart && this.aChart.isSelected) {
            if (this.activeBasket != -1) {
                // if (this.boxes[0] !== undefined && this.selectedSymbol != this.boxes[0])
                // {
                //     this.selectedSymbol = this.boxes[0];
                //     this.aChart.symbol = this.selectedSymbol;
                //     this.aChart.onSelectNewSymbol(this.selectedSymbol);
                // }
            }
        }

        if (this.tempSelectedSymbol != "") {
            this.selectedSymbol = this.tempSelectedSymbol;
        }

        this.tempSelectedSymbol = "";

        if (this.boxes.length > 0 && this.boxes.indexOf(this.selectedSymbol) == -1) this.selectedSymbol = this.boxes[0];

        this.workspace.AppTick();
    }

    set activeBasket(v: number) {
        this.workspace.activeBasket = v;
    }

    get activeBasket() {
        return this.workspace.activeBasket;
    }

    public initSymbolListFix() {
        if (this.workspace.loadedSymbolsTypeSplit.forex.length > 0) {
            this.boxes = this.workspace.loadedSymbolsTypeSplit.forex;
        } else {
            setTimeout(() => {
                this.initSymbolListFix();
            }, 10);
        }
    }

    ngAfterViewInit(): void {
        this.initSymbolListFix();
    }

    private resetTraveling() {
        let periodNav = $(this.periodsSelector!.nativeElement).find(".periodsNav")[0];
        let periodNavContents = $(this.periodsSelector!.nativeElement).find(".periodsNavContent")[0];
        let pnAdvancerLeft = $(this.periodsSelector!.nativeElement).find(".pn-Advancer_Left")[0];
        let pnAdvancerRight = $(this.periodsSelector!.nativeElement).find(".pn-Advancer_Right")[0];

        // get the value of the transform, apply that to the current scroll position (so get the scroll pos first) and then remove the transform
        var styleOfTransform = window.getComputedStyle(periodNavContents, undefined);
        var tr =
            styleOfTransform.getPropertyValue("-webkit-transform") || styleOfTransform.getPropertyValue("transform");
        // If there is no transition we want to default to 0 and not null
        var amount = Math.abs(parseInt(tr.split(",")[4]) || 0);
        periodNavContents.style.transform = "none";
        periodNavContents.classList.add("periodsNavContent-no-transition");
        // Now lets set the scroll position
        if (this.periodsBarTravelDirection === "left") {
            periodNav.scrollLeft = periodNav.scrollLeft - amount;
        } else {
            periodNav.scrollLeft = periodNav.scrollLeft + amount;
        }
        this.periodsBarTravelling = false;
    }

    get rangeButton(): number {
        return this._rangeButton;
    }
    set rangeButton(v: number) {
        this._rangeButton = v > 4 ? 4 : v < 0 ? 0 : v;

        switch (this.rangeButton) {
            case 0:
                this.aChart.selectionRange = 110;
                break;
            case 1:
                this.aChart.selectionRange = 90;
                break;
            case 2:
                this.aChart.selectionRange = 70;
                break;
            case 3:
                this.aChart.selectionRange = 50;
                break;
            case 4:
                this.aChart.selectionRange = 30;
                break;
        }

        //  this.aChart.selectionRange=10*((5-this.rangeButton)*(5-this.rangeButton));
    }

    private _drawGrid = false;

    set drawGrid(v: boolean) {
        this._drawGrid = v;
        this.aChart.showGrid = v;
    }

    get drawGrid(): boolean {
        return this._drawGrid;
    }

    set showPriceIndicators(v: boolean) {
        this.aChart.showPriceIndicators = v;
    }

    get showPriceIndicators(): boolean {
        return this.aChart.showPriceIndicators;
    }

    showMenu(type: string): void {
        clearTimeout(this._timeOut);
        this.showChartTypes = 0;
        this.showZoomIndicators = 0;
        this.showGranulityTypes = 0;
        this.showChartGridDrawTypes = 0;
        switch (type) {
            case "showChartTypes":
                this.showChartTypes = 1;
                break;
            case "showZoomIndicators":
                this.showZoomIndicators = 1;
                break;
            case "showGranulityTypes":
                this.showGranulityTypes = 1;
                break;
            case "showChartGridDrawTypes":
                this.showChartGridDrawTypes = 1;
                break;
        }
    }

    hideMenu(type: string): void {
        this._timeOut = setTimeout(() => {
            switch (type) {
                case "showChartTypes":
                    this.showChartTypes = 0;
                    break;
                case "showZoomIndicators":
                    this.showZoomIndicators = 0;
                    break;
                case "showGranulityTypes":
                    this.showGranulityTypes = 0;
                    break;
                case "showChartGridDrawTypes":
                    this.showChartGridDrawTypes = 0;
                    break;
            }
        }, 100);
    }

    set showZoomIndicators(mode: number) {
        this._showZoomIndicators = mode;
    }

    get showZoomIndicators(): number {
        return this._showZoomIndicators;
    }

    set showGranulityTypes(mode: number) {
        this._showGranulityTypes = mode;
    }

    get showGranulityTypes(): number {
        return this._showGranulityTypes;
    }

    // public _periods = historyPeriods().filter(x => {
    //     if (this.workspace.currentProvider == "OANDA") {
    //         return x.Oanda == true;
    //     } else {
    //         return x.Standard == true;
    //     }
    // });

    public get periods(): {
        id: number;
        label: string;
        css: string;
        Order: number;
        Standard?: boolean;
        Oanda?: boolean;
    }[] {
        return this.workspace.periodsList;
    }

    public set periods(
        value: {
            id: number;
            label: string;
            css: string;
            Order: number;
            Standard?: boolean;
            Oanda?: boolean;
        }[]
    ) {
        this.workspace.periodsList = value;
    }

    private _currentPeriodCss: string = "ico-m1";

    set currentPeriodCss(v: string) {
        this._currentPeriodCss = v;
    }

    get currentPeriodCss(): string {
        return this._currentPeriodCss;
    }

    get historyPeriodLabel(): string {
        let filtered = this.periods.filter(p => p.id == this.historyPeriodType);
        if (filtered.length < 1) return "";
        return filtered[0].label;
    }

    get historyPeriodType(): HistoryItemPeriod {
        let correctPeriod = this.workspace.getCorrectPeriod(this.aChart.Config.Period[this.Config.DisplayMode]);

        return Number(correctPeriod);
    }

    set historyPeriodType(v: HistoryItemPeriod) {
        this.aChart.period = v;
        this.currentPeriodCss = getPeriodCss(this.historyPeriodType);
        this.setMonitorPeriods(v);
    }

    setMonitorPeriods(v: HistoryItemPeriod) {
        if (this.aChartId == "ach1") {
            this.globaGridMode.longSymbolPeriod.next(v);
        }

        if (this.aChartId == "ach2") {
            this.globaGridMode.midSymbolPeriod.next(v);
        }

        if (this.aChartId == "ach3") {
            this.globaGridMode.shortSymbolPeriod.next(v);
        }

        if (this.aChartId == "ach4") {
            this.globaGridMode.entrySymbolPeriod.next(v);
        }
    }

    changeZoomLevel(direction: number): void {
        let newRangeButton: number = Number(this._rangeButton) + direction;

        if (newRangeButton >= 0 && newRangeButton < 6) {
            this.rangeButton = newRangeButton;
            if (newRangeButton > 5) {
                this.rangeButton = 5;
            }

            // if(this.aChart) {
            //   this.aChart.selectionRange=this.aChart.selectionRange*this.rangeButton;
            // }
        }
    }

    StockSeriesType = StockSeriesType;

    get chartType(): StockSeriesType {
        if (this.aChart) {
            return this.aChart.chartSerieType;
        } else {
            return StockSeriesType.CANDLESTICK;
        }
    }

    set chartType(v: StockSeriesType) {
        if (this.aChart) {
            this.aChart.chartSerieType = v;
        }
    }

    set showChartTypes(mode: number) {
        this._showChartTypes = mode;
    }

    get showChartTypes(): number {
        return this._showChartTypes;
    }

    private _showChartGridDrawTypes: number = 0;

    set showChartGridDrawTypes(v: number) {
        this._showChartGridDrawTypes = v;
    }

    get showChartGridDrawTypes(): number {
        return this._showChartGridDrawTypes;
    }

    get PIP(): number {
        return this.aChart ? this.aChart.pipValue : 0;
    }

    toogleChartTooltip() {
        this.Config.ShowTooltip = !this.Config.ShowTooltip;
    }

    onChangeKeyDown(e: any) {
        if (e.keyCode == KEY_CODE.UP_ARROW) {
            this.setPreviousSymbol();
        }

        if (e.keyCode == KEY_CODE.DOWN_ARROW) {
            this.setNextSymbol();
        }
    }

    /***SELECT BOX */
    async onChange(e: any) {
        if (e !== undefined) {
            this.dataService.currentlyChanged = this.aChart.itemID;
            this.aChart.symbol = e;
        }
    }

    async onPeriodChange(e: any) {
        if (e !== undefined) {
            // this.aChart.symbol = e;
        }
    }

    public chartTypes: { id: StockSeriesType; label: string }[] = [
        {
            id: StockSeriesType.CANDLESTICK,
            label: "Candlestick"
        },
        {
            id: StockSeriesType.LINE,
            label: "Line"
        },
        {
            id: StockSeriesType.OHLC,
            label: "OHLC"
        },
        {
            id: StockSeriesType.PRICEPOINTLINE,
            label: "Price point"
        }
    ];

    // onChangeKeyDownPeriod(e: any) {
    //     if (e.keyCode == KEY_CODE.UP_ARROW) {
    //         this.setPreviousSymbol();
    //     }

    //     if (e.keyCode == KEY_CODE.DOWN_ARROW) {
    //         this.setNextSymbol();
    //     }
    // }

    private determineOverflow(content: HTMLElement, container: HTMLElement): string {
        var containerMetrics = container.getBoundingClientRect();
        var containerMetricsRight = Math.ceil(containerMetrics.right);
        var containerMetricsLeft = Math.floor(containerMetrics.left);
        var contentMetrics = content.getBoundingClientRect();
        var contentMetricsRight = Math.floor(contentMetrics.right);
        var contentMetricsLeft = Math.ceil(contentMetrics.left);
        if (containerMetricsLeft > contentMetricsLeft && containerMetricsRight < contentMetricsRight) {
            return "both";
        } else if (contentMetricsLeft < containerMetricsLeft) {
            return "left";
        } else if (contentMetricsRight > containerMetricsRight) {
            return "right";
        } else {
            return "none";
        }
    }

    private refreshDataOverflow(content: HTMLElement, container: HTMLElement) {
        let overflow = this.determineOverflow(content, container);
        container.setAttribute("data-overflowing", overflow);
    }

    @HostListener("window:keyup", ["$event"])
    keyEvent(event: KeyboardEvent) {
        if (this.aChart && this.aChart.isSelected) {
            if (event.keyCode === KEY_CODE.RIGHT_ARROW) {
                this.setNextPeriod();
            }

            if (event.keyCode === KEY_CODE.LEFT_ARROW) {
                this.setPreviousPeriod();
            }

            if (event.keyCode === KEY_CODE.UP_ARROW) {
                this.setPreviousSymbol();
            }

            if (event.keyCode === KEY_CODE.DOWN_ARROW) {
                this.setNextSymbol();
            }
        }
    }

    public setNextPeriod() {
        let neighbours = this.currentPeriodNeighbours(this.historyPeriodType);
        if (neighbours[1] !== undefined) {
            this.historyPeriodType = neighbours[1];
        }
    }

    public setPreviousPeriod() {
        let neighbours = this.currentPeriodNeighbours(this.historyPeriodType);
        if (neighbours[0] !== undefined) {
            this.historyPeriodType = neighbours[0];
        }
    }

    public setNextSymbol() {
        let neighbours = this.currentSymbolNeighbours(this.selectedSymbol);
        if (neighbours[1] != -1) {
            this.selectedSymbol = neighbours[1];
            this.onChange(this.selectedSymbol);
        }
    }

    public setPreviousSymbol() {
        let neighbours = this.currentSymbolNeighbours(this.selectedSymbol);

        if (neighbours[0] != -1) {
            this.selectedSymbol = neighbours[0];
            this.onChange(this.selectedSymbol);
        }
    }

    public currentPeriodNeighbours(period: HistoryItemPeriod) {
        let t: any = this.periods;
        let a: HistoryItemPeriod[] = [];
        t.forEach((element: any) => {
            a.push(element.id);
        });
        var index = t.findIndex(function(item: any) {
            return item.id == period;
        });
        return [a[index - 1], a[index + 1]];
    }

    public currentSymbolNeighbours(symbol: string) {
        var index = this.boxes.findIndex(function(item: any) {
            return item == symbol;
        });
        if (this.boxes[index - 1] !== undefined && this.boxes[index + 1] !== undefined) {
            return [this.boxes[index - 1], this.boxes[index + 1]];
        } else if (this.boxes[index - 1] === undefined) {
            return [-1, this.boxes[index + 1]];
        } else {
            return [this.boxes[index - 1], -1];
        }
    }

    private _showChartTypesButton: boolean = true;
    public get showChartTypesButton(): boolean {
        return this._showChartTypesButton;
    }
    public set showChartTypesButton(value: boolean) {
        this._showChartTypesButton = value;
    }

    // @ViewChild("scaled") public scaled!: ElementRef;

    // get panelWidth() {
    //     if (this.scaled !== undefined) {
    //         return this.scaled.nativeElement.offsetWidth || 235;
    //     } else {
    //         return 235;
    //     }
    // }

    // public calculateScale() {
    //     let w = this.panelWidth;
    //     let unit = 235;

    //     let scale = w / unit;
    //     return {
    //         transform: "scale(" + scale + ")"
    //     };
    // }
}

export enum KEY_CODE {
    RIGHT_ARROW = 39,
    LEFT_ARROW = 37,
    UP_ARROW = 38,
    DOWN_ARROW = 40
}
